
// Define enums
export enum Unit {
    Meter,
    Foot,
    Yard,
    Second,
    MeterPerSecond,
    MilesPerHour,
    FeetPerSecond,
    Degree,
    RotationsPerMinute,
    Celsius,
    Fahrenheit,
    Kelvin,
    UnitLess,
    Inch,
    Centimeter,
    Percentage,
    MeterPerSecondSquared,
    FeetPerSecondSquared,
    Millimeter,
	Empty
}

export enum UnitSystem {
    Metric = 1,
    European = 2,
    Us = 3,
    Japanese = 4,
    Korean = 5,
    NotDefined = 6
}

export function fromLocale(loc: string): UnitSystem {
    switch (loc) {
        case "en-us":
            return UnitSystem.Us;
        case "ja-jp":
            return UnitSystem.Japanese;
        case "ko-kr":
            return UnitSystem.Korean;
        default:
            return UnitSystem.European;
    }
}
